import { BoxArrowUpRight } from "react-bootstrap-icons";

export const ProjectCard = ({ title, description, imgUrl, url }) => {
    return (
        <div className="proj-imgbx">
            <img src={imgUrl} alt={title} />
            <div className="proj-txtx">
                <h4>{title}</h4>
                <span>{description}</span>
                {url && (
                    <div>
                        <a
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="view-live-btn"
                        >
                            View Live <BoxArrowUpRight size={11} />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};
